import { createStore } from 'vuex'

export default createStore({
  state: {
    datosemp: {},
    receptores: {},
    configEnvio: {},
    files: [],
    documentos: [],
    numReceptores: [],
    datos: {},
    firmas: '',
    paginaActual: '',
    content: '',
    pub_titulo: '',
    params: {},
    carpetas: [],
  },
  getters: {
    get({ state }) {
      return state;
    }
  },
  mutations: {
    setDatosemp(state, data) {
      state.datosemp = data;
    },
    setCarpetas(state, data) {
      state.carpetas = data;
    },
    setReceptores(state, data) {
      state.receptores = data;
    },
    setConfigEnvio(state, data) {
      state.configEnvio = data;
    },
    setFiles(state, data) {
      state.files = data;
    },
    setNumReceptores(state, data) {
      state.numReceptores = data;
    },
    setFirmas(state, data) {
      state.firmas = data;
    },
    setDocumentos(state, data) {
      state.documentos = data;
    },
    setPaginaActual(state, data) {
      state.paginaActual = data;
    },
    setContent(state, data) {
      state.content = data;
    },
    setPubTitulo(state, data) {
      state.pub_titulo = data;
    },
    setParams(state, data) {
      state.params = data;
    }
  },
  actions: {
    async fetchEdy(state, commit) {
      //
      commit("setEdy", 'Hola2')
    },
  },
  modules: {

  }
})
